var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"columns":_vm.cols,"data":_vm.tableData,"loading":_vm.loading,"border":"","width":_vm.cols.reduce((a,v)=>a+v.width,0)+5}},[(_vm.loading)?_c('BaseLoading'):_vm._e(),_c('div',{staticClass:"flex-wrap flex-right",staticStyle:{"font-size":"12px","color":"var(--subtext3)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }